import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as GC from '../../constants';
//////////////////////////////////////////////////

const selectRolesStore = (state) => state.roles;

const makeSelectTotalCount = () => createSelector(
  selectRolesStore,
  (state) => R.path([state.activeList], state.totalCount),
);

const makeSelectUsedReport = () => createSelector(
  selectRolesStore,
  ({ usedReport }) => usedReport,
);

const makeSelectRoleList = () => createSelector(
  selectRolesStore,
  ({ roleList }) => roleList,
);

const makeSelectRoleAvailableList = () => createSelector(
  selectRolesStore,
  ({ roleAvailableList }) => roleAvailableList,
);

const makeSelectDriverRoleAvailableList = () => createSelector(
  selectRolesStore,
  R.compose(
    R.filter(R.propEq(GC.USER_ROLE_TYPE_DRIVER, GC.FIELD_TYPE)),
    R.pathOr([], ['roleAvailableList'])
  ),
);

const makeSelectPermissionsGroupsList = () => createSelector(
  selectRolesStore,
  ({ permissionsGroupsList }) => permissionsGroupsList,
);

const makeSelectRolePermissionsGroupsList = () => createSelector(
  selectRolesStore,
  ({ editRoleUserPermissionGroupList }) => editRoleUserPermissionGroupList,
);

const makeSelectSelectedPermissionsGroupUnnormalized = () => createSelector(
  selectRolesStore,
  ({ permissionsGroupsListUnnormalized }) => permissionsGroupsListUnnormalized,
);

const makeSelectEditRoleInitialValues = () => createSelector(
  selectRolesStore,
  ({ editRoleInitialValues }) => editRoleInitialValues,
);

const makeSelectPermissionsList = () => createSelector(
  selectRolesStore,
  ({ permissionsList }) => permissionsList,
);
const makeSelectRoleType = () => createSelector(
  selectRolesStore,
  ({ roleType }) => roleType,
);

const makeSelectRoleSelectedDocumentTypes = () => createSelector(
  selectRolesStore,
  ({ roleSelectedDocumentTypes }) => roleSelectedDocumentTypes,
);

const makeSelectRoleListLoading = () => createSelector(
  selectRolesStore,
  ({ loading }) => loading,
);

const makeSelectActiveList = () => createSelector(
  selectRolesStore,
  (state) => state.activeList,
);

const makeSelectRoleListChoosed = () => createSelector(
  selectRolesStore,
  (state) => R.path([state.activeList], state),
);

const makeSelectDefaultPermissions = () => createSelector(
  selectRolesStore,
  ({ defaultPermissions }) => defaultPermissions,
);

const makeSelectPermissions = () => createSelector(
  selectRolesStore,
  ({ permissions }) => permissions,
);


export {
  selectRolesStore,
  makeSelectRoleList,
  makeSelectRoleType,
  makeSelectUsedReport,
  makeSelectTotalCount,
  makeSelectActiveList,
  makeSelectPermissions,
  makeSelectRoleListChoosed,
  makeSelectRoleListLoading,
  makeSelectPermissionsList,
  makeSelectRoleAvailableList,
  makeSelectDefaultPermissions,
  makeSelectPermissionsGroupsList,
  makeSelectEditRoleInitialValues,
  makeSelectDriverRoleAvailableList,
  makeSelectRoleSelectedDocumentTypes,
  makeSelectRolePermissionsGroupsList,
  makeSelectSelectedPermissionsGroupUnnormalized,
};
